module.exports = __webpack_public_path__ + "static/services-img2-8e923fd1811b03e94cf6d00fe886da64.png";